import { IReleaseNote } from "../types"

export const RELEASE_3_3_0: IReleaseNote = {
    status: "UPCOMING",
    title: "v3.3.0",
    date: "TBC",
    releaseType: "Minor",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "ENA Connect Direct 3.3.0 brings the DNO-facing side of Plug-in Solar notifications online. DNOs can now view, filter and respond to consumer Plug-in Solar notifications, and assign an export MPAN.",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "This release contains no changes to your functionality",
        },
        {
            heading: "For installers using our APIs",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            subtitle: "Feature Summary",
            bullets: [
                "Plug-in Solar Notifications: A new page lists Plug-in Solar notifications submitted to your DNO with filtering options",
                "Assign Export MPAN: On a current notification, you can now assign an export MPAN. This triggers a confirmation email to the consumer if customer emails are enabled for your DNO",
            ],
        },
        {
            subtitle: "The following changes have been added:",
            bullets: [
                "A new Plug-in Solar Notifications page has been added to Connect Direct, accessible from the DNO home screen navigation",
                "Notifications can be filtered and searched",
                "Historic notifications (superseded by a newer notification for the same address) are read-only",
                "On a current notification, an export MPAN can be assigned. The export MPAN must belong to your DNO",
            ],
        },
        {
            heading: "For DNOs using our APIs",
            subtitle: "Feature Summary",
            bullets: [
                "Two new endpoints are available to retrieve Plug-in Solar notifications and assign an export MPAN",
            ],
        },
        {
            subtitle: "The following endpoints have been added:",
            bullets: [
                "Notification listing: POST /dno-sol/v1/notifications - retrieve Plug-in Solar notifications submitted to your DNO. Supports filtering by status, sorting by date, and pagination",
                "Assign Export MPAN: POST /dno-sol/v1/export-mpan - assign an export MPAN to a current notification belonging to your DNO",
            ],
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
}
